// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documentUploadDropzoneContainer {
	margin-bottom: 30px;
}

.documentUploadDropzoneContainer .filepicker {
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background-color: transparent;
	min-height: 200px;
	border: 2px dashed var(--primary-border);
	font-family: var(--font-family-base);
}

.documentUploadDropzoneContainer .filepicker .dz-message {
	display: none;
}

.documentUploadDropzoneContainer .dzInputContainer .dz-hidden-input {
	z-index: -1;
}

.documentUploadDropzoneIcon {
	position: absolute;
	top: calc(50% - 17px);
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: -1;
}

.documentUploadDropzonePlaceholder {
	position: absolute;
	top: calc((50% + 10px));
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	margin-top: 12px;
	color: var(--primary-foreground);
	z-index: -1;
	padding: 0 12px;
}

@media (max-width: 480px) {
	.documentUploadDropzonePlaceholder {
		top: calc((50% + 20px));
	}
}

/* become a host start */
.documentUploadDropzoneContainer .filepicker {
	min-height: 262px;
	margin-bottom: 12px;
}

.becomeHostDropzoneContainer .filepicker .dz-message {
	display: block;
	padding: 0 12px;
	font-size: 18px;
	font-weight: 500;
	line-height: normal;
	position: absolute;
	top: calc((50% + 10px));
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	margin-top: 12px;
	margin-bottom: 0;
	color: var(--primary-foreground);
	z-index: -1;
	padding: 0 12px;
}

.becomeHostDropzoneUploadText {
	font-size: 14px;
	font-weight: 400;
	line-height: 24px;
	color: var(--secondary-foreground);
}

@media (max-width: 1120px) and (min-width: 768px) {
	.becomeHostDropzoneContainer .filepicker .dz-message {
		top: calc((50% + 20px));
	}
}

@media (max-width: 550px) {
	.becomeHostDropzoneContainer .filepicker .dz-message {
		top: calc((50% + 20px));
	}
}

/* become a host end */

.becomeHostDropzoneContainer .dz-preview .dz-details .dz-filename:hover,
.documentUploadDropzoneContainer .dz-preview .dz-details .dz-filename:hover {
	overflow: hidden;
	text-overflow: ellipsis;
}

.documentUploadDropzoneContainer .dz-preview.dz-image-preview,
.becomeHostDropzoneContainer .dz-preview.dz-image-preview {
	background: transparent;
}

/* ============================================================
   PHOTOS UPLOAD CARD — estilos del card derecho (Photos.js)
   ============================================================ */

/* Wrapper principal */
.photoUploadWrapper {
	display: flex;
	flex-direction: column;
	gap: 0;
	height: 100%;
}

/* ---- Header del card ---- */
.photoUploadHeader {
	display: flex;
	align-items: flex-start;
	gap: 14px;
	padding: 28px 36px 20px;
	border-bottom: 1px solid #e8f0f8;
}

.photoUploadHeaderIcon {
	flex-shrink: 0;
	width: 70px;
	height: 70px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.photoUploadHeaderText {
	flex: 1;
}

.photoUploadTitle {
	font-size: 28px !important;
	font-family: var(--font-family-base) !important;
	font-weight: bold;
	color: var(--secondary-oscuro);
	margin: 0 0 6px;
	line-height: 1.3;
	letter-spacing: -0.2px;
}

.photoUploadSubtitle {
	font-size: 18px;
	font-family: var(--font-family-base) !important;
	color: var(--secondary-oscuro);
	line-height: 1.55;
	margin: 0;
}

/* ---- Zona de dropzone ---- */

.photoDropzoneArea .filepicker {
	background: transparent !important;
	border: none !important;
	min-height: 175px !important;
	border-radius: 16px !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
}

/* Ocultar el mensaje por defecto del dropzone */
.photoDropzoneArea .filepicker .dz-message {
	display: none !important;
}

.photoDropzoneInner {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 6px;
	padding: 28px 20px;
	pointer-events: none;
}

.photoDropzoneIconWrap {
	margin-bottom: 6px;
}

.photoDropzoneLabel {
	font-size: 15px;
	font-weight: 600;
	color: #1e293b;
	margin: 0;
	line-height: 1.3;
}

.photoDropzoneHint {
	font-size: 13px;
	color: #94a3b8;
	margin: 0 0 10px;
}




/* ---- Nota informativa ---- */
.photoUploadInfoNote {
	display: flex;
	align-items: center;
	gap: 7px;
	margin: 4px 36px 4px 0;
	font-size: 12px;
	color: #90caf9;
	line-height: 1.5;
}

/* ============================================= */
/* PHOTO UPLOAD REDESIGN                         */
/* ============================================= */

.photoUploadWrapper {
	display: flex;
	flex-direction: column;
	gap: 20px;
}

/* Header */
.photoUploadHeader {
	display: flex;
	align-items: flex-start;
	gap: 14px;
}

.photoUploadHeaderIcon {
	flex-shrink: 0;
}

.photoUploadHeaderText {
	flex: 1;
}

/* Título con icono */
.photoUploadTitleRow {
	display: flex;
	align-items: flex-start;
	gap: 10px;
	margin-bottom: 6px;
}

.photoUploadTitleIcon {
	flex-shrink: 0;
	width: 70px;
	height: 70px;
}

.photoUploadTitle {
	font-size: 18px;
	font-family: var(--font-family-base) !important;
	font-weight: 700;
	color: #1a2233;
	margin: 0;
	line-height: 1.3;
}

.photoUploadSubtitle {
	font-size: 13px;
	font-family: var(--font-family-base) !important;
	white-space: pre-line;
	color: #6b7280;
	margin: 0;
	line-height: 1.6;
}

/* Dropzone area */
.photoDropzoneArea .filepicker {
	border: 2px dashed var(--primary-color) !important;
	border-radius: 16px !important;
	background-color: #ffffff !important;
	min-height: 200px !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	cursor: pointer;
	margin: 0px 40px 0px 40px;
	transition: border-color 0.2s, background-color 0.2s;
}

.photoDropzoneArea .filepicker:hover {
	border-color: #2196F3 !important;
	background-color: #eef6fe !important;
}

.photoDropzoneArea .filepicker .dz-message {
	display: none !important;
}

.photoDropzoneInner {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 28px 20px;
	z-index: 1;
	pointer-events: none;
}

.photoDropzoneIconWrap {
	margin-bottom: 4px;
}

.photoDropzoneLabel {
	font-size: 15px;
	font-weight: 600;
	color: #1a2233;
	margin: 0;
	text-align: center;
}

.photoDropzoneHint {
	font-size: 13px;
	color: #9ca3af;
	margin: 0;
	text-align: center;
}

.photoSelectBtn {
	pointer-events: all;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	margin-top: 8px;
	padding: 9px 22px;
	border: 1.8px solid var(--primary-color);
	border-radius: 50px;
	background: #f7fbff;
	color: var(--primary-color);
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: border-color 0.2s, background-color 0.2s, color 0.2s;
	font-family: inherit;
}

.photoSelectBtn:hover {
	border-color: #2196F3;
	color: #2196F3;
	background: #f0f8ff;
}

/* Info note */
.photoUploadInfoNote {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 12px;
	color: #9ca3af;
	line-height: 1.5;
	margin-left: 40px;
}

/* Grid de fotos — alineado con el dropzone (mismos márgenes) */
.photoGridArea {
	margin: 0 5px;
}`, "",{"version":3,"sources":["webpack://./src/styles/documentUploadDropzone.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,6BAA6B;CAC7B,iBAAiB;CACjB,wCAAwC;CACxC,oCAAoC;AACrC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,SAAS;CACT,gCAAgC;CAChC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,SAAS;CACT,gCAAgC;CAChC,WAAW;CACX,gBAAgB;CAChB,gCAAgC;CAChC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC;EACC,uBAAuB;CACxB;AACD;;AAEA,wBAAwB;AACxB;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;CAClB,uBAAuB;CACvB,SAAS;CACT,gCAAgC;CAChC,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,gCAAgC;CAChC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,kCAAkC;AACnC;;AAEA;CACC;EACC,uBAAuB;CACxB;AACD;;AAEA;CACC;EACC,uBAAuB;CACxB;AACD;;AAEA,sBAAsB;;AAEtB;;CAEC,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;;CAEC,uBAAuB;AACxB;;AAEA;;iEAEiE;;AAEjE,sBAAsB;AACtB;CACC,aAAa;CACb,sBAAsB;CACtB,MAAM;CACN,YAAY;AACb;;AAEA,8BAA8B;AAC9B;CACC,aAAa;CACb,uBAAuB;CACvB,SAAS;CACT,uBAAuB;CACvB,gCAAgC;AACjC;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,OAAO;AACR;;AAEA;CACC,0BAA0B;CAC1B,+CAA+C;CAC/C,iBAAiB;CACjB,8BAA8B;CAC9B,eAAe;CACf,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,+CAA+C;CAC/C,8BAA8B;CAC9B,iBAAiB;CACjB,SAAS;AACV;;AAEA,+BAA+B;;AAE/B;CACC,kCAAkC;CAClC,uBAAuB;CACvB,4BAA4B;CAC5B,8BAA8B;CAC9B,wBAAwB;CACxB,8BAA8B;CAC9B,kCAAkC;AACnC;;AAEA,gDAAgD;AAChD;CACC,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,QAAQ;CACR,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;;;;;AAKA,+BAA+B;AAC/B;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,sBAAsB;CACtB,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;;AAEA,kDAAkD;AAClD,kDAAkD;AAClD,kDAAkD;;AAElD;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA,WAAW;AACX;CACC,aAAa;CACb,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,OAAO;AACR;;AAEA,qBAAqB;AACrB;CACC,aAAa;CACb,uBAAuB;CACvB,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;AACb;;AAEA;CACC,eAAe;CACf,+CAA+C;CAC/C,gBAAgB;CAChB,cAAc;CACd,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,+CAA+C;CAC/C,qBAAqB;CACrB,cAAc;CACd,SAAS;CACT,gBAAgB;AACjB;;AAEA,kBAAkB;AAClB;CACC,kDAAkD;CAClD,8BAA8B;CAC9B,oCAAoC;CACpC,4BAA4B;CAC5B,wBAAwB;CACxB,8BAA8B;CAC9B,kCAAkC;CAClC,eAAe;CACf,yBAAyB;CACzB,oDAAoD;AACrD;;AAEA;CACC,gCAAgC;CAChC,oCAAoC;AACrC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,QAAQ;CACR,kBAAkB;CAClB,UAAU;CACV,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,iBAAiB;CACjB,wCAAwC;CACxC,mBAAmB;CACnB,mBAAmB;CACnB,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,gEAAgE;CAChE,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,mBAAmB;AACpB;;AAEA,cAAc;AACd;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA,+DAA+D;AAC/D;CACC,aAAa;AACd","sourcesContent":[".documentUploadDropzoneContainer {\n\tmargin-bottom: 30px;\n}\n\n.documentUploadDropzoneContainer .filepicker {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\toverflow: hidden;\n\tbackground-color: transparent;\n\tmin-height: 200px;\n\tborder: 2px dashed var(--primary-border);\n\tfont-family: var(--font-family-base);\n}\n\n.documentUploadDropzoneContainer .filepicker .dz-message {\n\tdisplay: none;\n}\n\n.documentUploadDropzoneContainer .dzInputContainer .dz-hidden-input {\n\tz-index: -1;\n}\n\n.documentUploadDropzoneIcon {\n\tposition: absolute;\n\ttop: calc(50% - 17px);\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tz-index: -1;\n}\n\n.documentUploadDropzonePlaceholder {\n\tposition: absolute;\n\ttop: calc((50% + 10px));\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: 100%;\n\tmargin-top: 12px;\n\tcolor: var(--primary-foreground);\n\tz-index: -1;\n\tpadding: 0 12px;\n}\n\n@media (max-width: 480px) {\n\t.documentUploadDropzonePlaceholder {\n\t\ttop: calc((50% + 20px));\n\t}\n}\n\n/* become a host start */\n.documentUploadDropzoneContainer .filepicker {\n\tmin-height: 262px;\n\tmargin-bottom: 12px;\n}\n\n.becomeHostDropzoneContainer .filepicker .dz-message {\n\tdisplay: block;\n\tpadding: 0 12px;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tline-height: normal;\n\tposition: absolute;\n\ttop: calc((50% + 10px));\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: 100%;\n\tmargin-top: 12px;\n\tmargin-bottom: 0;\n\tcolor: var(--primary-foreground);\n\tz-index: -1;\n\tpadding: 0 12px;\n}\n\n.becomeHostDropzoneUploadText {\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tline-height: 24px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1120px) and (min-width: 768px) {\n\t.becomeHostDropzoneContainer .filepicker .dz-message {\n\t\ttop: calc((50% + 20px));\n\t}\n}\n\n@media (max-width: 550px) {\n\t.becomeHostDropzoneContainer .filepicker .dz-message {\n\t\ttop: calc((50% + 20px));\n\t}\n}\n\n/* become a host end */\n\n.becomeHostDropzoneContainer .dz-preview .dz-details .dz-filename:hover,\n.documentUploadDropzoneContainer .dz-preview .dz-details .dz-filename:hover {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.documentUploadDropzoneContainer .dz-preview.dz-image-preview,\n.becomeHostDropzoneContainer .dz-preview.dz-image-preview {\n\tbackground: transparent;\n}\n\n/* ============================================================\n   PHOTOS UPLOAD CARD — estilos del card derecho (Photos.js)\n   ============================================================ */\n\n/* Wrapper principal */\n.photoUploadWrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0;\n\theight: 100%;\n}\n\n/* ---- Header del card ---- */\n.photoUploadHeader {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 14px;\n\tpadding: 28px 36px 20px;\n\tborder-bottom: 1px solid #e8f0f8;\n}\n\n.photoUploadHeaderIcon {\n\tflex-shrink: 0;\n\twidth: 70px;\n\theight: 70px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.photoUploadHeaderText {\n\tflex: 1;\n}\n\n.photoUploadTitle {\n\tfont-size: 28px !important;\n\tfont-family: var(--font-family-base) !important;\n\tfont-weight: bold;\n\tcolor: var(--secondary-oscuro);\n\tmargin: 0 0 6px;\n\tline-height: 1.3;\n\tletter-spacing: -0.2px;\n}\n\n.photoUploadSubtitle {\n\tfont-size: 18px;\n\tfont-family: var(--font-family-base) !important;\n\tcolor: var(--secondary-oscuro);\n\tline-height: 1.55;\n\tmargin: 0;\n}\n\n/* ---- Zona de dropzone ---- */\n\n.photoDropzoneArea .filepicker {\n\tbackground: transparent !important;\n\tborder: none !important;\n\tmin-height: 175px !important;\n\tborder-radius: 16px !important;\n\tdisplay: flex !important;\n\talign-items: center !important;\n\tjustify-content: center !important;\n}\n\n/* Ocultar el mensaje por defecto del dropzone */\n.photoDropzoneArea .filepicker .dz-message {\n\tdisplay: none !important;\n}\n\n.photoDropzoneInner {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 6px;\n\tpadding: 28px 20px;\n\tpointer-events: none;\n}\n\n.photoDropzoneIconWrap {\n\tmargin-bottom: 6px;\n}\n\n.photoDropzoneLabel {\n\tfont-size: 15px;\n\tfont-weight: 600;\n\tcolor: #1e293b;\n\tmargin: 0;\n\tline-height: 1.3;\n}\n\n.photoDropzoneHint {\n\tfont-size: 13px;\n\tcolor: #94a3b8;\n\tmargin: 0 0 10px;\n}\n\n\n\n\n/* ---- Nota informativa ---- */\n.photoUploadInfoNote {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 7px;\n\tmargin: 4px 36px 4px 0;\n\tfont-size: 12px;\n\tcolor: #90caf9;\n\tline-height: 1.5;\n}\n\n/* ============================================= */\n/* PHOTO UPLOAD REDESIGN                         */\n/* ============================================= */\n\n.photoUploadWrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 20px;\n}\n\n/* Header */\n.photoUploadHeader {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 14px;\n}\n\n.photoUploadHeaderIcon {\n\tflex-shrink: 0;\n}\n\n.photoUploadHeaderText {\n\tflex: 1;\n}\n\n/* Título con icono */\n.photoUploadTitleRow {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 10px;\n\tmargin-bottom: 6px;\n}\n\n.photoUploadTitleIcon {\n\tflex-shrink: 0;\n\twidth: 70px;\n\theight: 70px;\n}\n\n.photoUploadTitle {\n\tfont-size: 18px;\n\tfont-family: var(--font-family-base) !important;\n\tfont-weight: 700;\n\tcolor: #1a2233;\n\tmargin: 0;\n\tline-height: 1.3;\n}\n\n.photoUploadSubtitle {\n\tfont-size: 13px;\n\tfont-family: var(--font-family-base) !important;\n\twhite-space: pre-line;\n\tcolor: #6b7280;\n\tmargin: 0;\n\tline-height: 1.6;\n}\n\n/* Dropzone area */\n.photoDropzoneArea .filepicker {\n\tborder: 2px dashed var(--primary-color) !important;\n\tborder-radius: 16px !important;\n\tbackground-color: #ffffff !important;\n\tmin-height: 200px !important;\n\tdisplay: flex !important;\n\talign-items: center !important;\n\tjustify-content: center !important;\n\tcursor: pointer;\n\tmargin: 0px 40px 0px 40px;\n\ttransition: border-color 0.2s, background-color 0.2s;\n}\n\n.photoDropzoneArea .filepicker:hover {\n\tborder-color: #2196F3 !important;\n\tbackground-color: #eef6fe !important;\n}\n\n.photoDropzoneArea .filepicker .dz-message {\n\tdisplay: none !important;\n}\n\n.photoDropzoneInner {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 8px;\n\tpadding: 28px 20px;\n\tz-index: 1;\n\tpointer-events: none;\n}\n\n.photoDropzoneIconWrap {\n\tmargin-bottom: 4px;\n}\n\n.photoDropzoneLabel {\n\tfont-size: 15px;\n\tfont-weight: 600;\n\tcolor: #1a2233;\n\tmargin: 0;\n\ttext-align: center;\n}\n\n.photoDropzoneHint {\n\tfont-size: 13px;\n\tcolor: #9ca3af;\n\tmargin: 0;\n\ttext-align: center;\n}\n\n.photoSelectBtn {\n\tpointer-events: all;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-top: 8px;\n\tpadding: 9px 22px;\n\tborder: 1.8px solid var(--primary-color);\n\tborder-radius: 50px;\n\tbackground: #f7fbff;\n\tcolor: var(--primary-color);\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tcursor: pointer;\n\ttransition: border-color 0.2s, background-color 0.2s, color 0.2s;\n\tfont-family: inherit;\n}\n\n.photoSelectBtn:hover {\n\tborder-color: #2196F3;\n\tcolor: #2196F3;\n\tbackground: #f0f8ff;\n}\n\n/* Info note */\n.photoUploadInfoNote {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tfont-size: 12px;\n\tcolor: #9ca3af;\n\tline-height: 1.5;\n\tmargin-left: 40px;\n}\n\n/* Grid de fotos — alineado con el dropzone (mismos márgenes) */\n.photoGridArea {\n\tmargin: 0 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
